export enum PlayerUIFocusKeys {
  SubButton = "PLAYER_UI:SUB_BUTTON",
  TrackButton = "PLAYER_UI:TRACK_BUTTON",
  StreamQuality = "PLAYER_UI:STREAM_QUALITY",
  Repeat = "PLAYER_UI:REPEAT",
  Shuffle = "PLAYER_UI:SHUFFLE",
  Favorite = "PLAYER_UI:FAVORITE",
  PlayerUI = "PLAYER_UI:UI_SECTION",
  PlayButton = "PLAYER_UI:PLAY_BUTTON",
  ProgressBar = "PLAYER_UI:PROGRESS_BAR",
  ButtonGroupMiddle = "PLAYER_UI:BUTTON_GROUP_MIDDLE",
  ButtonGroupLeft = "PLAYER_UI:BUTTON_GROUP_LEFT",
  ButtonGroupRight = "PLAYER_UI:BUTTON_GROUP_RIGHT",
  SubtitlePrefix = "PLAYER_UI:SUBTITLES:",
  TrackPrefix = "PLAYER_UI:AUDIOTRACKS:",
}
